export default __webpack_public_path__ + "static/media/3160.1d71406a.png";